//
// DO NOT EDIT! Autogenerated by bin/index-geography.mts
//
import { default as AF_subnational1 } from "./regions/AF.subnational1.json"
import { default as AF_subnational2 } from "./regions/AF.subnational2.json"
import { default as AL_subnational1 } from "./regions/AL.subnational1.json"
import { default as AL_subnational2 } from "./regions/AL.subnational2.json"
import { default as DZ_subnational1 } from "./regions/DZ.subnational1.json"
import { default as DZ_subnational2 } from "./regions/DZ.subnational2.json"
import { default as AS_subnational1 } from "./regions/AS.subnational1.json"
import { default as AS_subnational2 } from "./regions/AS.subnational2.json"
import { default as AD_subnational1 } from "./regions/AD.subnational1.json"
import { default as AD_subnational2 } from "./regions/AD.subnational2.json"
import { default as AO_subnational1 } from "./regions/AO.subnational1.json"
import { default as AO_subnational2 } from "./regions/AO.subnational2.json"
import { default as AI_subnational1 } from "./regions/AI.subnational1.json"
import { default as AI_subnational2 } from "./regions/AI.subnational2.json"
import { default as AQ_subnational1 } from "./regions/AQ.subnational1.json"
import { default as AQ_subnational2 } from "./regions/AQ.subnational2.json"
import { default as AG_subnational1 } from "./regions/AG.subnational1.json"
import { default as AG_subnational2 } from "./regions/AG.subnational2.json"
import { default as AR_subnational1 } from "./regions/AR.subnational1.json"
import { default as AR_subnational2 } from "./regions/AR.subnational2.json"
import { default as AM_subnational1 } from "./regions/AM.subnational1.json"
import { default as AM_subnational2 } from "./regions/AM.subnational2.json"
import { default as AW_subnational1 } from "./regions/AW.subnational1.json"
import { default as AW_subnational2 } from "./regions/AW.subnational2.json"
import { default as AC_subnational1 } from "./regions/AC.subnational1.json"
import { default as AC_subnational2 } from "./regions/AC.subnational2.json"
import { default as AU_subnational1 } from "./regions/AU.subnational1.json"
import { default as AU_subnational2 } from "./regions/AU.subnational2.json"
import { default as AT_subnational1 } from "./regions/AT.subnational1.json"
import { default as AT_subnational2 } from "./regions/AT.subnational2.json"
import { default as AZ_subnational1 } from "./regions/AZ.subnational1.json"
import { default as AZ_subnational2 } from "./regions/AZ.subnational2.json"
import { default as BS_subnational1 } from "./regions/BS.subnational1.json"
import { default as BS_subnational2 } from "./regions/BS.subnational2.json"
import { default as BH_subnational1 } from "./regions/BH.subnational1.json"
import { default as BH_subnational2 } from "./regions/BH.subnational2.json"
import { default as BD_subnational1 } from "./regions/BD.subnational1.json"
import { default as BD_subnational2 } from "./regions/BD.subnational2.json"
import { default as BB_subnational1 } from "./regions/BB.subnational1.json"
import { default as BB_subnational2 } from "./regions/BB.subnational2.json"
import { default as BY_subnational1 } from "./regions/BY.subnational1.json"
import { default as BY_subnational2 } from "./regions/BY.subnational2.json"
import { default as BE_subnational1 } from "./regions/BE.subnational1.json"
import { default as BE_subnational2 } from "./regions/BE.subnational2.json"
import { default as BZ_subnational1 } from "./regions/BZ.subnational1.json"
import { default as BZ_subnational2 } from "./regions/BZ.subnational2.json"
import { default as BJ_subnational1 } from "./regions/BJ.subnational1.json"
import { default as BJ_subnational2 } from "./regions/BJ.subnational2.json"
import { default as BM_subnational1 } from "./regions/BM.subnational1.json"
import { default as BM_subnational2 } from "./regions/BM.subnational2.json"
import { default as BT_subnational1 } from "./regions/BT.subnational1.json"
import { default as BT_subnational2 } from "./regions/BT.subnational2.json"
import { default as BO_subnational1 } from "./regions/BO.subnational1.json"
import { default as BO_subnational2 } from "./regions/BO.subnational2.json"
import { default as BA_subnational1 } from "./regions/BA.subnational1.json"
import { default as BA_subnational2 } from "./regions/BA.subnational2.json"
import { default as BW_subnational1 } from "./regions/BW.subnational1.json"
import { default as BW_subnational2 } from "./regions/BW.subnational2.json"
import { default as BV_subnational1 } from "./regions/BV.subnational1.json"
import { default as BV_subnational2 } from "./regions/BV.subnational2.json"
import { default as BR_subnational1 } from "./regions/BR.subnational1.json"
import { default as BR_subnational2 } from "./regions/BR.subnational2.json"
import { default as IO_subnational1 } from "./regions/IO.subnational1.json"
import { default as IO_subnational2 } from "./regions/IO.subnational2.json"
import { default as BN_subnational1 } from "./regions/BN.subnational1.json"
import { default as BN_subnational2 } from "./regions/BN.subnational2.json"
import { default as BG_subnational1 } from "./regions/BG.subnational1.json"
import { default as BG_subnational2 } from "./regions/BG.subnational2.json"
import { default as BF_subnational1 } from "./regions/BF.subnational1.json"
import { default as BF_subnational2 } from "./regions/BF.subnational2.json"
import { default as BI_subnational1 } from "./regions/BI.subnational1.json"
import { default as BI_subnational2 } from "./regions/BI.subnational2.json"
import { default as KH_subnational1 } from "./regions/KH.subnational1.json"
import { default as KH_subnational2 } from "./regions/KH.subnational2.json"
import { default as CM_subnational1 } from "./regions/CM.subnational1.json"
import { default as CM_subnational2 } from "./regions/CM.subnational2.json"
import { default as CA_subnational1 } from "./regions/CA.subnational1.json"
import { default as CA_subnational2 } from "./regions/CA.subnational2.json"
import { default as CV_subnational1 } from "./regions/CV.subnational1.json"
import { default as CV_subnational2 } from "./regions/CV.subnational2.json"
import { default as BQ_subnational1 } from "./regions/BQ.subnational1.json"
import { default as BQ_subnational2 } from "./regions/BQ.subnational2.json"
import { default as KY_subnational1 } from "./regions/KY.subnational1.json"
import { default as KY_subnational2 } from "./regions/KY.subnational2.json"
import { default as CF_subnational1 } from "./regions/CF.subnational1.json"
import { default as CF_subnational2 } from "./regions/CF.subnational2.json"
import { default as TD_subnational1 } from "./regions/TD.subnational1.json"
import { default as TD_subnational2 } from "./regions/TD.subnational2.json"
import { default as CL_subnational1 } from "./regions/CL.subnational1.json"
import { default as CL_subnational2 } from "./regions/CL.subnational2.json"
import { default as CN_subnational1 } from "./regions/CN.subnational1.json"
import { default as CN_subnational2 } from "./regions/CN.subnational2.json"
import { default as CX_subnational1 } from "./regions/CX.subnational1.json"
import { default as CX_subnational2 } from "./regions/CX.subnational2.json"
import { default as CP_subnational1 } from "./regions/CP.subnational1.json"
import { default as CP_subnational2 } from "./regions/CP.subnational2.json"
import { default as CC_subnational1 } from "./regions/CC.subnational1.json"
import { default as CC_subnational2 } from "./regions/CC.subnational2.json"
import { default as CO_subnational1 } from "./regions/CO.subnational1.json"
import { default as CO_subnational2 } from "./regions/CO.subnational2.json"
import { default as KM_subnational1 } from "./regions/KM.subnational1.json"
import { default as KM_subnational2 } from "./regions/KM.subnational2.json"
import { default as CG_subnational1 } from "./regions/CG.subnational1.json"
import { default as CG_subnational2 } from "./regions/CG.subnational2.json"
import { default as CK_subnational1 } from "./regions/CK.subnational1.json"
import { default as CK_subnational2 } from "./regions/CK.subnational2.json"
import { default as CS_subnational1 } from "./regions/CS.subnational1.json"
import { default as CS_subnational2 } from "./regions/CS.subnational2.json"
import { default as CR_subnational1 } from "./regions/CR.subnational1.json"
import { default as CR_subnational2 } from "./regions/CR.subnational2.json"
import { default as CI_subnational1 } from "./regions/CI.subnational1.json"
import { default as CI_subnational2 } from "./regions/CI.subnational2.json"
import { default as HR_subnational1 } from "./regions/HR.subnational1.json"
import { default as HR_subnational2 } from "./regions/HR.subnational2.json"
import { default as CU_subnational1 } from "./regions/CU.subnational1.json"
import { default as CU_subnational2 } from "./regions/CU.subnational2.json"
import { default as CW_subnational1 } from "./regions/CW.subnational1.json"
import { default as CW_subnational2 } from "./regions/CW.subnational2.json"
import { default as CY_subnational1 } from "./regions/CY.subnational1.json"
import { default as CY_subnational2 } from "./regions/CY.subnational2.json"
import { default as CZ_subnational1 } from "./regions/CZ.subnational1.json"
import { default as CZ_subnational2 } from "./regions/CZ.subnational2.json"
import { default as DK_subnational1 } from "./regions/DK.subnational1.json"
import { default as DK_subnational2 } from "./regions/DK.subnational2.json"
import { default as DJ_subnational1 } from "./regions/DJ.subnational1.json"
import { default as DJ_subnational2 } from "./regions/DJ.subnational2.json"
import { default as DM_subnational1 } from "./regions/DM.subnational1.json"
import { default as DM_subnational2 } from "./regions/DM.subnational2.json"
import { default as DO_subnational1 } from "./regions/DO.subnational1.json"
import { default as DO_subnational2 } from "./regions/DO.subnational2.json"
import { default as CD_subnational1 } from "./regions/CD.subnational1.json"
import { default as CD_subnational2 } from "./regions/CD.subnational2.json"
import { default as EC_subnational1 } from "./regions/EC.subnational1.json"
import { default as EC_subnational2 } from "./regions/EC.subnational2.json"
import { default as EG_subnational1 } from "./regions/EG.subnational1.json"
import { default as EG_subnational2 } from "./regions/EG.subnational2.json"
import { default as SV_subnational1 } from "./regions/SV.subnational1.json"
import { default as SV_subnational2 } from "./regions/SV.subnational2.json"
import { default as GQ_subnational1 } from "./regions/GQ.subnational1.json"
import { default as GQ_subnational2 } from "./regions/GQ.subnational2.json"
import { default as ER_subnational1 } from "./regions/ER.subnational1.json"
import { default as ER_subnational2 } from "./regions/ER.subnational2.json"
import { default as EE_subnational1 } from "./regions/EE.subnational1.json"
import { default as EE_subnational2 } from "./regions/EE.subnational2.json"
import { default as SZ_subnational1 } from "./regions/SZ.subnational1.json"
import { default as SZ_subnational2 } from "./regions/SZ.subnational2.json"
import { default as ET_subnational1 } from "./regions/ET.subnational1.json"
import { default as ET_subnational2 } from "./regions/ET.subnational2.json"
import { default as FK_subnational1 } from "./regions/FK.subnational1.json"
import { default as FK_subnational2 } from "./regions/FK.subnational2.json"
import { default as FO_subnational1 } from "./regions/FO.subnational1.json"
import { default as FO_subnational2 } from "./regions/FO.subnational2.json"
import { default as FJ_subnational1 } from "./regions/FJ.subnational1.json"
import { default as FJ_subnational2 } from "./regions/FJ.subnational2.json"
import { default as FI_subnational1 } from "./regions/FI.subnational1.json"
import { default as FI_subnational2 } from "./regions/FI.subnational2.json"
import { default as FR_subnational1 } from "./regions/FR.subnational1.json"
import { default as FR_subnational2 } from "./regions/FR.subnational2.json"
import { default as GF_subnational1 } from "./regions/GF.subnational1.json"
import { default as GF_subnational2 } from "./regions/GF.subnational2.json"
import { default as PF_subnational1 } from "./regions/PF.subnational1.json"
import { default as PF_subnational2 } from "./regions/PF.subnational2.json"
import { default as TF_subnational1 } from "./regions/TF.subnational1.json"
import { default as TF_subnational2 } from "./regions/TF.subnational2.json"
import { default as GA_subnational1 } from "./regions/GA.subnational1.json"
import { default as GA_subnational2 } from "./regions/GA.subnational2.json"
import { default as GM_subnational1 } from "./regions/GM.subnational1.json"
import { default as GM_subnational2 } from "./regions/GM.subnational2.json"
import { default as GE_subnational1 } from "./regions/GE.subnational1.json"
import { default as GE_subnational2 } from "./regions/GE.subnational2.json"
import { default as DE_subnational1 } from "./regions/DE.subnational1.json"
import { default as DE_subnational2 } from "./regions/DE.subnational2.json"
import { default as GH_subnational1 } from "./regions/GH.subnational1.json"
import { default as GH_subnational2 } from "./regions/GH.subnational2.json"
import { default as GI_subnational1 } from "./regions/GI.subnational1.json"
import { default as GI_subnational2 } from "./regions/GI.subnational2.json"
import { default as GR_subnational1 } from "./regions/GR.subnational1.json"
import { default as GR_subnational2 } from "./regions/GR.subnational2.json"
import { default as GL_subnational1 } from "./regions/GL.subnational1.json"
import { default as GL_subnational2 } from "./regions/GL.subnational2.json"
import { default as GD_subnational1 } from "./regions/GD.subnational1.json"
import { default as GD_subnational2 } from "./regions/GD.subnational2.json"
import { default as GP_subnational1 } from "./regions/GP.subnational1.json"
import { default as GP_subnational2 } from "./regions/GP.subnational2.json"
import { default as GU_subnational1 } from "./regions/GU.subnational1.json"
import { default as GU_subnational2 } from "./regions/GU.subnational2.json"
import { default as GT_subnational1 } from "./regions/GT.subnational1.json"
import { default as GT_subnational2 } from "./regions/GT.subnational2.json"
import { default as GG_subnational1 } from "./regions/GG.subnational1.json"
import { default as GG_subnational2 } from "./regions/GG.subnational2.json"
import { default as GN_subnational1 } from "./regions/GN.subnational1.json"
import { default as GN_subnational2 } from "./regions/GN.subnational2.json"
import { default as GW_subnational1 } from "./regions/GW.subnational1.json"
import { default as GW_subnational2 } from "./regions/GW.subnational2.json"
import { default as GY_subnational1 } from "./regions/GY.subnational1.json"
import { default as GY_subnational2 } from "./regions/GY.subnational2.json"
import { default as HT_subnational1 } from "./regions/HT.subnational1.json"
import { default as HT_subnational2 } from "./regions/HT.subnational2.json"
import { default as HM_subnational1 } from "./regions/HM.subnational1.json"
import { default as HM_subnational2 } from "./regions/HM.subnational2.json"
import { default as XX_subnational1 } from "./regions/XX.subnational1.json"
import { default as XX_subnational2 } from "./regions/XX.subnational2.json"
import { default as HN_subnational1 } from "./regions/HN.subnational1.json"
import { default as HN_subnational2 } from "./regions/HN.subnational2.json"
import { default as HK_subnational1 } from "./regions/HK.subnational1.json"
import { default as HK_subnational2 } from "./regions/HK.subnational2.json"
import { default as HU_subnational1 } from "./regions/HU.subnational1.json"
import { default as HU_subnational2 } from "./regions/HU.subnational2.json"
import { default as IS_subnational1 } from "./regions/IS.subnational1.json"
import { default as IS_subnational2 } from "./regions/IS.subnational2.json"
import { default as IN_subnational1 } from "./regions/IN.subnational1.json"
import { default as IN_subnational2 } from "./regions/IN.subnational2.json"
import { default as ID_subnational1 } from "./regions/ID.subnational1.json"
import { default as ID_subnational2 } from "./regions/ID.subnational2.json"
import { default as IR_subnational1 } from "./regions/IR.subnational1.json"
import { default as IR_subnational2 } from "./regions/IR.subnational2.json"
import { default as IQ_subnational1 } from "./regions/IQ.subnational1.json"
import { default as IQ_subnational2 } from "./regions/IQ.subnational2.json"
import { default as IE_subnational1 } from "./regions/IE.subnational1.json"
import { default as IE_subnational2 } from "./regions/IE.subnational2.json"
import { default as IM_subnational1 } from "./regions/IM.subnational1.json"
import { default as IM_subnational2 } from "./regions/IM.subnational2.json"
import { default as IL_subnational1 } from "./regions/IL.subnational1.json"
import { default as IL_subnational2 } from "./regions/IL.subnational2.json"
import { default as IT_subnational1 } from "./regions/IT.subnational1.json"
import { default as IT_subnational2 } from "./regions/IT.subnational2.json"
import { default as JM_subnational1 } from "./regions/JM.subnational1.json"
import { default as JM_subnational2 } from "./regions/JM.subnational2.json"
import { default as JP_subnational1 } from "./regions/JP.subnational1.json"
import { default as JP_subnational2 } from "./regions/JP.subnational2.json"
import { default as JE_subnational1 } from "./regions/JE.subnational1.json"
import { default as JE_subnational2 } from "./regions/JE.subnational2.json"
import { default as JO_subnational1 } from "./regions/JO.subnational1.json"
import { default as JO_subnational2 } from "./regions/JO.subnational2.json"
import { default as KZ_subnational1 } from "./regions/KZ.subnational1.json"
import { default as KZ_subnational2 } from "./regions/KZ.subnational2.json"
import { default as KE_subnational1 } from "./regions/KE.subnational1.json"
import { default as KE_subnational2 } from "./regions/KE.subnational2.json"
import { default as KI_subnational1 } from "./regions/KI.subnational1.json"
import { default as KI_subnational2 } from "./regions/KI.subnational2.json"
import { default as XK_subnational1 } from "./regions/XK.subnational1.json"
import { default as XK_subnational2 } from "./regions/XK.subnational2.json"
import { default as KW_subnational1 } from "./regions/KW.subnational1.json"
import { default as KW_subnational2 } from "./regions/KW.subnational2.json"
import { default as KG_subnational1 } from "./regions/KG.subnational1.json"
import { default as KG_subnational2 } from "./regions/KG.subnational2.json"
import { default as LA_subnational1 } from "./regions/LA.subnational1.json"
import { default as LA_subnational2 } from "./regions/LA.subnational2.json"
import { default as LV_subnational1 } from "./regions/LV.subnational1.json"
import { default as LV_subnational2 } from "./regions/LV.subnational2.json"
import { default as LB_subnational1 } from "./regions/LB.subnational1.json"
import { default as LB_subnational2 } from "./regions/LB.subnational2.json"
import { default as LS_subnational1 } from "./regions/LS.subnational1.json"
import { default as LS_subnational2 } from "./regions/LS.subnational2.json"
import { default as LR_subnational1 } from "./regions/LR.subnational1.json"
import { default as LR_subnational2 } from "./regions/LR.subnational2.json"
import { default as LY_subnational1 } from "./regions/LY.subnational1.json"
import { default as LY_subnational2 } from "./regions/LY.subnational2.json"
import { default as LI_subnational1 } from "./regions/LI.subnational1.json"
import { default as LI_subnational2 } from "./regions/LI.subnational2.json"
import { default as LT_subnational1 } from "./regions/LT.subnational1.json"
import { default as LT_subnational2 } from "./regions/LT.subnational2.json"
import { default as LU_subnational1 } from "./regions/LU.subnational1.json"
import { default as LU_subnational2 } from "./regions/LU.subnational2.json"
import { default as MO_subnational1 } from "./regions/MO.subnational1.json"
import { default as MO_subnational2 } from "./regions/MO.subnational2.json"
import { default as MG_subnational1 } from "./regions/MG.subnational1.json"
import { default as MG_subnational2 } from "./regions/MG.subnational2.json"
import { default as MW_subnational1 } from "./regions/MW.subnational1.json"
import { default as MW_subnational2 } from "./regions/MW.subnational2.json"
import { default as MY_subnational1 } from "./regions/MY.subnational1.json"
import { default as MY_subnational2 } from "./regions/MY.subnational2.json"
import { default as MV_subnational1 } from "./regions/MV.subnational1.json"
import { default as MV_subnational2 } from "./regions/MV.subnational2.json"
import { default as ML_subnational1 } from "./regions/ML.subnational1.json"
import { default as ML_subnational2 } from "./regions/ML.subnational2.json"
import { default as MT_subnational1 } from "./regions/MT.subnational1.json"
import { default as MT_subnational2 } from "./regions/MT.subnational2.json"
import { default as MH_subnational1 } from "./regions/MH.subnational1.json"
import { default as MH_subnational2 } from "./regions/MH.subnational2.json"
import { default as MQ_subnational1 } from "./regions/MQ.subnational1.json"
import { default as MQ_subnational2 } from "./regions/MQ.subnational2.json"
import { default as MR_subnational1 } from "./regions/MR.subnational1.json"
import { default as MR_subnational2 } from "./regions/MR.subnational2.json"
import { default as MU_subnational1 } from "./regions/MU.subnational1.json"
import { default as MU_subnational2 } from "./regions/MU.subnational2.json"
import { default as YT_subnational1 } from "./regions/YT.subnational1.json"
import { default as YT_subnational2 } from "./regions/YT.subnational2.json"
import { default as MX_subnational1 } from "./regions/MX.subnational1.json"
import { default as MX_subnational2 } from "./regions/MX.subnational2.json"
import { default as FM_subnational1 } from "./regions/FM.subnational1.json"
import { default as FM_subnational2 } from "./regions/FM.subnational2.json"
import { default as MD_subnational1 } from "./regions/MD.subnational1.json"
import { default as MD_subnational2 } from "./regions/MD.subnational2.json"
import { default as MC_subnational1 } from "./regions/MC.subnational1.json"
import { default as MC_subnational2 } from "./regions/MC.subnational2.json"
import { default as MN_subnational1 } from "./regions/MN.subnational1.json"
import { default as MN_subnational2 } from "./regions/MN.subnational2.json"
import { default as ME_subnational1 } from "./regions/ME.subnational1.json"
import { default as ME_subnational2 } from "./regions/ME.subnational2.json"
import { default as MS_subnational1 } from "./regions/MS.subnational1.json"
import { default as MS_subnational2 } from "./regions/MS.subnational2.json"
import { default as MA_subnational1 } from "./regions/MA.subnational1.json"
import { default as MA_subnational2 } from "./regions/MA.subnational2.json"
import { default as MZ_subnational1 } from "./regions/MZ.subnational1.json"
import { default as MZ_subnational2 } from "./regions/MZ.subnational2.json"
import { default as MM_subnational1 } from "./regions/MM.subnational1.json"
import { default as MM_subnational2 } from "./regions/MM.subnational2.json"
import { default as NA_subnational1 } from "./regions/NA.subnational1.json"
import { default as NA_subnational2 } from "./regions/NA.subnational2.json"
import { default as NR_subnational1 } from "./regions/NR.subnational1.json"
import { default as NR_subnational2 } from "./regions/NR.subnational2.json"
import { default as NP_subnational1 } from "./regions/NP.subnational1.json"
import { default as NP_subnational2 } from "./regions/NP.subnational2.json"
import { default as NL_subnational1 } from "./regions/NL.subnational1.json"
import { default as NL_subnational2 } from "./regions/NL.subnational2.json"
import { default as NC_subnational1 } from "./regions/NC.subnational1.json"
import { default as NC_subnational2 } from "./regions/NC.subnational2.json"
import { default as NZ_subnational1 } from "./regions/NZ.subnational1.json"
import { default as NZ_subnational2 } from "./regions/NZ.subnational2.json"
import { default as NI_subnational1 } from "./regions/NI.subnational1.json"
import { default as NI_subnational2 } from "./regions/NI.subnational2.json"
import { default as NE_subnational1 } from "./regions/NE.subnational1.json"
import { default as NE_subnational2 } from "./regions/NE.subnational2.json"
import { default as NG_subnational1 } from "./regions/NG.subnational1.json"
import { default as NG_subnational2 } from "./regions/NG.subnational2.json"
import { default as NU_subnational1 } from "./regions/NU.subnational1.json"
import { default as NU_subnational2 } from "./regions/NU.subnational2.json"
import { default as NF_subnational1 } from "./regions/NF.subnational1.json"
import { default as NF_subnational2 } from "./regions/NF.subnational2.json"
import { default as MP_subnational1 } from "./regions/MP.subnational1.json"
import { default as MP_subnational2 } from "./regions/MP.subnational2.json"
import { default as KP_subnational1 } from "./regions/KP.subnational1.json"
import { default as KP_subnational2 } from "./regions/KP.subnational2.json"
import { default as MK_subnational1 } from "./regions/MK.subnational1.json"
import { default as MK_subnational2 } from "./regions/MK.subnational2.json"
import { default as NO_subnational1 } from "./regions/NO.subnational1.json"
import { default as NO_subnational2 } from "./regions/NO.subnational2.json"
import { default as OM_subnational1 } from "./regions/OM.subnational1.json"
import { default as OM_subnational2 } from "./regions/OM.subnational2.json"
import { default as PK_subnational1 } from "./regions/PK.subnational1.json"
import { default as PK_subnational2 } from "./regions/PK.subnational2.json"
import { default as PW_subnational1 } from "./regions/PW.subnational1.json"
import { default as PW_subnational2 } from "./regions/PW.subnational2.json"
import { default as PS_subnational1 } from "./regions/PS.subnational1.json"
import { default as PS_subnational2 } from "./regions/PS.subnational2.json"
import { default as PA_subnational1 } from "./regions/PA.subnational1.json"
import { default as PA_subnational2 } from "./regions/PA.subnational2.json"
import { default as PG_subnational1 } from "./regions/PG.subnational1.json"
import { default as PG_subnational2 } from "./regions/PG.subnational2.json"
import { default as PY_subnational1 } from "./regions/PY.subnational1.json"
import { default as PY_subnational2 } from "./regions/PY.subnational2.json"
import { default as PE_subnational1 } from "./regions/PE.subnational1.json"
import { default as PE_subnational2 } from "./regions/PE.subnational2.json"
import { default as PH_subnational1 } from "./regions/PH.subnational1.json"
import { default as PH_subnational2 } from "./regions/PH.subnational2.json"
import { default as PN_subnational1 } from "./regions/PN.subnational1.json"
import { default as PN_subnational2 } from "./regions/PN.subnational2.json"
import { default as PL_subnational1 } from "./regions/PL.subnational1.json"
import { default as PL_subnational2 } from "./regions/PL.subnational2.json"
import { default as PT_subnational1 } from "./regions/PT.subnational1.json"
import { default as PT_subnational2 } from "./regions/PT.subnational2.json"
import { default as PR_subnational1 } from "./regions/PR.subnational1.json"
import { default as PR_subnational2 } from "./regions/PR.subnational2.json"
import { default as QA_subnational1 } from "./regions/QA.subnational1.json"
import { default as QA_subnational2 } from "./regions/QA.subnational2.json"
import { default as RE_subnational1 } from "./regions/RE.subnational1.json"
import { default as RE_subnational2 } from "./regions/RE.subnational2.json"
import { default as RO_subnational1 } from "./regions/RO.subnational1.json"
import { default as RO_subnational2 } from "./regions/RO.subnational2.json"
import { default as RU_subnational1 } from "./regions/RU.subnational1.json"
import { default as RU_subnational2 } from "./regions/RU.subnational2.json"
import { default as RW_subnational1 } from "./regions/RW.subnational1.json"
import { default as RW_subnational2 } from "./regions/RW.subnational2.json"
import { default as BL_subnational1 } from "./regions/BL.subnational1.json"
import { default as BL_subnational2 } from "./regions/BL.subnational2.json"
import { default as SH_subnational1 } from "./regions/SH.subnational1.json"
import { default as SH_subnational2 } from "./regions/SH.subnational2.json"
import { default as KN_subnational1 } from "./regions/KN.subnational1.json"
import { default as KN_subnational2 } from "./regions/KN.subnational2.json"
import { default as LC_subnational1 } from "./regions/LC.subnational1.json"
import { default as LC_subnational2 } from "./regions/LC.subnational2.json"
import { default as MF_subnational1 } from "./regions/MF.subnational1.json"
import { default as MF_subnational2 } from "./regions/MF.subnational2.json"
import { default as PM_subnational1 } from "./regions/PM.subnational1.json"
import { default as PM_subnational2 } from "./regions/PM.subnational2.json"
import { default as VC_subnational1 } from "./regions/VC.subnational1.json"
import { default as VC_subnational2 } from "./regions/VC.subnational2.json"
import { default as WS_subnational1 } from "./regions/WS.subnational1.json"
import { default as WS_subnational2 } from "./regions/WS.subnational2.json"
import { default as SM_subnational1 } from "./regions/SM.subnational1.json"
import { default as SM_subnational2 } from "./regions/SM.subnational2.json"
import { default as ST_subnational1 } from "./regions/ST.subnational1.json"
import { default as ST_subnational2 } from "./regions/ST.subnational2.json"
import { default as SA_subnational1 } from "./regions/SA.subnational1.json"
import { default as SA_subnational2 } from "./regions/SA.subnational2.json"
import { default as SN_subnational1 } from "./regions/SN.subnational1.json"
import { default as SN_subnational2 } from "./regions/SN.subnational2.json"
import { default as RS_subnational1 } from "./regions/RS.subnational1.json"
import { default as RS_subnational2 } from "./regions/RS.subnational2.json"
import { default as SC_subnational1 } from "./regions/SC.subnational1.json"
import { default as SC_subnational2 } from "./regions/SC.subnational2.json"
import { default as SL_subnational1 } from "./regions/SL.subnational1.json"
import { default as SL_subnational2 } from "./regions/SL.subnational2.json"
import { default as SG_subnational1 } from "./regions/SG.subnational1.json"
import { default as SG_subnational2 } from "./regions/SG.subnational2.json"
import { default as SX_subnational1 } from "./regions/SX.subnational1.json"
import { default as SX_subnational2 } from "./regions/SX.subnational2.json"
import { default as SK_subnational1 } from "./regions/SK.subnational1.json"
import { default as SK_subnational2 } from "./regions/SK.subnational2.json"
import { default as SI_subnational1 } from "./regions/SI.subnational1.json"
import { default as SI_subnational2 } from "./regions/SI.subnational2.json"
import { default as SB_subnational1 } from "./regions/SB.subnational1.json"
import { default as SB_subnational2 } from "./regions/SB.subnational2.json"
import { default as SO_subnational1 } from "./regions/SO.subnational1.json"
import { default as SO_subnational2 } from "./regions/SO.subnational2.json"
import { default as ZA_subnational1 } from "./regions/ZA.subnational1.json"
import { default as ZA_subnational2 } from "./regions/ZA.subnational2.json"
import { default as GS_subnational1 } from "./regions/GS.subnational1.json"
import { default as GS_subnational2 } from "./regions/GS.subnational2.json"
import { default as KR_subnational1 } from "./regions/KR.subnational1.json"
import { default as KR_subnational2 } from "./regions/KR.subnational2.json"
import { default as SS_subnational1 } from "./regions/SS.subnational1.json"
import { default as SS_subnational2 } from "./regions/SS.subnational2.json"
import { default as ES_subnational1 } from "./regions/ES.subnational1.json"
import { default as ES_subnational2 } from "./regions/ES.subnational2.json"
import { default as LK_subnational1 } from "./regions/LK.subnational1.json"
import { default as LK_subnational2 } from "./regions/LK.subnational2.json"
import { default as SD_subnational1 } from "./regions/SD.subnational1.json"
import { default as SD_subnational2 } from "./regions/SD.subnational2.json"
import { default as SR_subnational1 } from "./regions/SR.subnational1.json"
import { default as SR_subnational2 } from "./regions/SR.subnational2.json"
import { default as SJ_subnational1 } from "./regions/SJ.subnational1.json"
import { default as SJ_subnational2 } from "./regions/SJ.subnational2.json"
import { default as SE_subnational1 } from "./regions/SE.subnational1.json"
import { default as SE_subnational2 } from "./regions/SE.subnational2.json"
import { default as CH_subnational1 } from "./regions/CH.subnational1.json"
import { default as CH_subnational2 } from "./regions/CH.subnational2.json"
import { default as SY_subnational1 } from "./regions/SY.subnational1.json"
import { default as SY_subnational2 } from "./regions/SY.subnational2.json"
import { default as TW_subnational1 } from "./regions/TW.subnational1.json"
import { default as TW_subnational2 } from "./regions/TW.subnational2.json"
import { default as TJ_subnational1 } from "./regions/TJ.subnational1.json"
import { default as TJ_subnational2 } from "./regions/TJ.subnational2.json"
import { default as TZ_subnational1 } from "./regions/TZ.subnational1.json"
import { default as TZ_subnational2 } from "./regions/TZ.subnational2.json"
import { default as TH_subnational1 } from "./regions/TH.subnational1.json"
import { default as TH_subnational2 } from "./regions/TH.subnational2.json"
import { default as TL_subnational1 } from "./regions/TL.subnational1.json"
import { default as TL_subnational2 } from "./regions/TL.subnational2.json"
import { default as TG_subnational1 } from "./regions/TG.subnational1.json"
import { default as TG_subnational2 } from "./regions/TG.subnational2.json"
import { default as TK_subnational1 } from "./regions/TK.subnational1.json"
import { default as TK_subnational2 } from "./regions/TK.subnational2.json"
import { default as TO_subnational1 } from "./regions/TO.subnational1.json"
import { default as TO_subnational2 } from "./regions/TO.subnational2.json"
import { default as TT_subnational1 } from "./regions/TT.subnational1.json"
import { default as TT_subnational2 } from "./regions/TT.subnational2.json"
import { default as TN_subnational1 } from "./regions/TN.subnational1.json"
import { default as TN_subnational2 } from "./regions/TN.subnational2.json"
import { default as TR_subnational1 } from "./regions/TR.subnational1.json"
import { default as TR_subnational2 } from "./regions/TR.subnational2.json"
import { default as TM_subnational1 } from "./regions/TM.subnational1.json"
import { default as TM_subnational2 } from "./regions/TM.subnational2.json"
import { default as TC_subnational1 } from "./regions/TC.subnational1.json"
import { default as TC_subnational2 } from "./regions/TC.subnational2.json"
import { default as TV_subnational1 } from "./regions/TV.subnational1.json"
import { default as TV_subnational2 } from "./regions/TV.subnational2.json"
import { default as UG_subnational1 } from "./regions/UG.subnational1.json"
import { default as UG_subnational2 } from "./regions/UG.subnational2.json"
import { default as UA_subnational1 } from "./regions/UA.subnational1.json"
import { default as UA_subnational2 } from "./regions/UA.subnational2.json"
import { default as AE_subnational1 } from "./regions/AE.subnational1.json"
import { default as AE_subnational2 } from "./regions/AE.subnational2.json"
import { default as GB_subnational1 } from "./regions/GB.subnational1.json"
import { default as GB_subnational2 } from "./regions/GB.subnational2.json"
import { default as US_subnational1 } from "./regions/US.subnational1.json"
import { default as US_subnational2 } from "./regions/US.subnational2.json"
import { default as UM_subnational1 } from "./regions/UM.subnational1.json"
import { default as UM_subnational2 } from "./regions/UM.subnational2.json"
import { default as UY_subnational1 } from "./regions/UY.subnational1.json"
import { default as UY_subnational2 } from "./regions/UY.subnational2.json"
import { default as UZ_subnational1 } from "./regions/UZ.subnational1.json"
import { default as UZ_subnational2 } from "./regions/UZ.subnational2.json"
import { default as VU_subnational1 } from "./regions/VU.subnational1.json"
import { default as VU_subnational2 } from "./regions/VU.subnational2.json"
import { default as VA_subnational1 } from "./regions/VA.subnational1.json"
import { default as VA_subnational2 } from "./regions/VA.subnational2.json"
import { default as VE_subnational1 } from "./regions/VE.subnational1.json"
import { default as VE_subnational2 } from "./regions/VE.subnational2.json"
import { default as VN_subnational1 } from "./regions/VN.subnational1.json"
import { default as VN_subnational2 } from "./regions/VN.subnational2.json"
import { default as VG_subnational1 } from "./regions/VG.subnational1.json"
import { default as VG_subnational2 } from "./regions/VG.subnational2.json"
import { default as VI_subnational1 } from "./regions/VI.subnational1.json"
import { default as VI_subnational2 } from "./regions/VI.subnational2.json"
import { default as WF_subnational1 } from "./regions/WF.subnational1.json"
import { default as WF_subnational2 } from "./regions/WF.subnational2.json"
import { default as EH_subnational1 } from "./regions/EH.subnational1.json"
import { default as EH_subnational2 } from "./regions/EH.subnational2.json"
import { default as YE_subnational1 } from "./regions/YE.subnational1.json"
import { default as YE_subnational2 } from "./regions/YE.subnational2.json"
import { default as ZM_subnational1 } from "./regions/ZM.subnational1.json"
import { default as ZM_subnational2 } from "./regions/ZM.subnational2.json"
import { default as ZW_subnational1 } from "./regions/ZW.subnational1.json"
import { default as ZW_subnational2 } from "./regions/ZW.subnational2.json"

export const Countries = [
  { code: "AF", name: "Afghanistan", states: AF_subnational1, counties: AF_subnational2 },
  { code: "AL", name: "Albania", states: AL_subnational1, counties: AL_subnational2 },
  { code: "DZ", name: "Algeria", states: DZ_subnational1, counties: DZ_subnational2 },
  { code: "AS", name: "American Samoa", states: AS_subnational1, counties: AS_subnational2 },
  { code: "AD", name: "Andorra", states: AD_subnational1, counties: AD_subnational2 },
  { code: "AO", name: "Angola", states: AO_subnational1, counties: AO_subnational2 },
  { code: "AI", name: "Anguilla", states: AI_subnational1, counties: AI_subnational2 },
  { code: "AQ", name: "Antarctica", states: AQ_subnational1, counties: AQ_subnational2 },
  { code: "AG", name: "Antigua and Barbuda", states: AG_subnational1, counties: AG_subnational2 },
  { code: "AR", name: "Argentina", states: AR_subnational1, counties: AR_subnational2 },
  { code: "AM", name: "Armenia", states: AM_subnational1, counties: AM_subnational2 },
  { code: "AW", name: "Aruba", states: AW_subnational1, counties: AW_subnational2 },
  { code: "AC", name: "Ashmore and Cartier Islands", states: AC_subnational1, counties: AC_subnational2 },
  { code: "AU", name: "Australia", states: AU_subnational1, counties: AU_subnational2 },
  { code: "AT", name: "Austria", states: AT_subnational1, counties: AT_subnational2 },
  { code: "AZ", name: "Azerbaijan", states: AZ_subnational1, counties: AZ_subnational2 },
  { code: "BS", name: "Bahamas", states: BS_subnational1, counties: BS_subnational2 },
  { code: "BH", name: "Bahrain", states: BH_subnational1, counties: BH_subnational2 },
  { code: "BD", name: "Bangladesh", states: BD_subnational1, counties: BD_subnational2 },
  { code: "BB", name: "Barbados", states: BB_subnational1, counties: BB_subnational2 },
  { code: "BY", name: "Belarus", states: BY_subnational1, counties: BY_subnational2 },
  { code: "BE", name: "Belgium", states: BE_subnational1, counties: BE_subnational2 },
  { code: "BZ", name: "Belize", states: BZ_subnational1, counties: BZ_subnational2 },
  { code: "BJ", name: "Benin", states: BJ_subnational1, counties: BJ_subnational2 },
  { code: "BM", name: "Bermuda", states: BM_subnational1, counties: BM_subnational2 },
  { code: "BT", name: "Bhutan", states: BT_subnational1, counties: BT_subnational2 },
  { code: "BO", name: "Bolivia", states: BO_subnational1, counties: BO_subnational2 },
  { code: "BA", name: "Bosnia and Herzegovina", states: BA_subnational1, counties: BA_subnational2 },
  { code: "BW", name: "Botswana", states: BW_subnational1, counties: BW_subnational2 },
  { code: "BV", name: "Bouvet Island", states: BV_subnational1, counties: BV_subnational2 },
  { code: "BR", name: "Brazil", states: BR_subnational1, counties: BR_subnational2 },
  { code: "IO", name: "British Indian Ocean Territory", states: IO_subnational1, counties: IO_subnational2 },
  { code: "BN", name: "Brunei", states: BN_subnational1, counties: BN_subnational2 },
  { code: "BG", name: "Bulgaria", states: BG_subnational1, counties: BG_subnational2 },
  { code: "BF", name: "Burkina Faso", states: BF_subnational1, counties: BF_subnational2 },
  { code: "BI", name: "Burundi", states: BI_subnational1, counties: BI_subnational2 },
  { code: "KH", name: "Cambodia", states: KH_subnational1, counties: KH_subnational2 },
  { code: "CM", name: "Cameroon", states: CM_subnational1, counties: CM_subnational2 },
  { code: "CA", name: "Canada", states: CA_subnational1, counties: CA_subnational2 },
  { code: "CV", name: "Cape Verde", states: CV_subnational1, counties: CV_subnational2 },
  { code: "BQ", name: "Caribbean Netherlands", states: BQ_subnational1, counties: BQ_subnational2 },
  { code: "KY", name: "Cayman Islands", states: KY_subnational1, counties: KY_subnational2 },
  { code: "CF", name: "Central African Republic", states: CF_subnational1, counties: CF_subnational2 },
  { code: "TD", name: "Chad", states: TD_subnational1, counties: TD_subnational2 },
  { code: "CL", name: "Chile", states: CL_subnational1, counties: CL_subnational2 },
  { code: "CN", name: "China", states: CN_subnational1, counties: CN_subnational2 },
  { code: "CX", name: "Christmas Island", states: CX_subnational1, counties: CX_subnational2 },
  { code: "CP", name: "Clipperton Island", states: CP_subnational1, counties: CP_subnational2 },
  { code: "CC", name: "Cocos (Keeling) Islands", states: CC_subnational1, counties: CC_subnational2 },
  { code: "CO", name: "Colombia", states: CO_subnational1, counties: CO_subnational2 },
  { code: "KM", name: "Comoros", states: KM_subnational1, counties: KM_subnational2 },
  { code: "CG", name: "Congo", states: CG_subnational1, counties: CG_subnational2 },
  { code: "CK", name: "Cook Islands", states: CK_subnational1, counties: CK_subnational2 },
  { code: "CS", name: "Coral Sea Islands", states: CS_subnational1, counties: CS_subnational2 },
  { code: "CR", name: "Costa Rica", states: CR_subnational1, counties: CR_subnational2 },
  { code: "CI", name: "Côte d'Ivoire", states: CI_subnational1, counties: CI_subnational2 },
  { code: "HR", name: "Croatia", states: HR_subnational1, counties: HR_subnational2 },
  { code: "CU", name: "Cuba", states: CU_subnational1, counties: CU_subnational2 },
  { code: "CW", name: "Curaçao", states: CW_subnational1, counties: CW_subnational2 },
  { code: "CY", name: "Cyprus", states: CY_subnational1, counties: CY_subnational2 },
  { code: "CZ", name: "Czech Republic", states: CZ_subnational1, counties: CZ_subnational2 },
  { code: "DK", name: "Denmark", states: DK_subnational1, counties: DK_subnational2 },
  { code: "DJ", name: "Djibouti", states: DJ_subnational1, counties: DJ_subnational2 },
  { code: "DM", name: "Dominica", states: DM_subnational1, counties: DM_subnational2 },
  { code: "DO", name: "Dominican Republic", states: DO_subnational1, counties: DO_subnational2 },
  { code: "CD", name: "DR Congo", states: CD_subnational1, counties: CD_subnational2 },
  { code: "EC", name: "Ecuador", states: EC_subnational1, counties: EC_subnational2 },
  { code: "EG", name: "Egypt", states: EG_subnational1, counties: EG_subnational2 },
  { code: "SV", name: "El Salvador", states: SV_subnational1, counties: SV_subnational2 },
  { code: "GQ", name: "Equatorial Guinea", states: GQ_subnational1, counties: GQ_subnational2 },
  { code: "ER", name: "Eritrea", states: ER_subnational1, counties: ER_subnational2 },
  { code: "EE", name: "Estonia", states: EE_subnational1, counties: EE_subnational2 },
  { code: "SZ", name: "Eswatini", states: SZ_subnational1, counties: SZ_subnational2 },
  { code: "ET", name: "Ethiopia", states: ET_subnational1, counties: ET_subnational2 },
  { code: "FK", name: "Falkland Islands (Malvinas)", states: FK_subnational1, counties: FK_subnational2 },
  { code: "FO", name: "Faroe Islands", states: FO_subnational1, counties: FO_subnational2 },
  { code: "FJ", name: "Fiji", states: FJ_subnational1, counties: FJ_subnational2 },
  { code: "FI", name: "Finland", states: FI_subnational1, counties: FI_subnational2 },
  { code: "FR", name: "France", states: FR_subnational1, counties: FR_subnational2 },
  { code: "GF", name: "French Guiana", states: GF_subnational1, counties: GF_subnational2 },
  { code: "PF", name: "French Polynesia", states: PF_subnational1, counties: PF_subnational2 },
  { code: "TF", name: "French Southern and Antarctic Lands", states: TF_subnational1, counties: TF_subnational2 },
  { code: "GA", name: "Gabon", states: GA_subnational1, counties: GA_subnational2 },
  { code: "GM", name: "Gambia", states: GM_subnational1, counties: GM_subnational2 },
  { code: "GE", name: "Georgia", states: GE_subnational1, counties: GE_subnational2 },
  { code: "DE", name: "Germany", states: DE_subnational1, counties: DE_subnational2 },
  { code: "GH", name: "Ghana", states: GH_subnational1, counties: GH_subnational2 },
  { code: "GI", name: "Gibraltar", states: GI_subnational1, counties: GI_subnational2 },
  { code: "GR", name: "Greece", states: GR_subnational1, counties: GR_subnational2 },
  { code: "GL", name: "Greenland", states: GL_subnational1, counties: GL_subnational2 },
  { code: "GD", name: "Grenada", states: GD_subnational1, counties: GD_subnational2 },
  { code: "GP", name: "Guadeloupe", states: GP_subnational1, counties: GP_subnational2 },
  { code: "GU", name: "Guam", states: GU_subnational1, counties: GU_subnational2 },
  { code: "GT", name: "Guatemala", states: GT_subnational1, counties: GT_subnational2 },
  { code: "GG", name: "Guernsey", states: GG_subnational1, counties: GG_subnational2 },
  { code: "GN", name: "Guinea", states: GN_subnational1, counties: GN_subnational2 },
  { code: "GW", name: "Guinea-Bissau", states: GW_subnational1, counties: GW_subnational2 },
  { code: "GY", name: "Guyana", states: GY_subnational1, counties: GY_subnational2 },
  { code: "HT", name: "Haiti", states: HT_subnational1, counties: HT_subnational2 },
  { code: "HM", name: "Heard Island and McDonald Islands", states: HM_subnational1, counties: HM_subnational2 },
  { code: "XX", name: "High Seas", states: XX_subnational1, counties: XX_subnational2 },
  { code: "HN", name: "Honduras", states: HN_subnational1, counties: HN_subnational2 },
  { code: "HK", name: "Hong Kong", states: HK_subnational1, counties: HK_subnational2 },
  { code: "HU", name: "Hungary", states: HU_subnational1, counties: HU_subnational2 },
  { code: "IS", name: "Iceland", states: IS_subnational1, counties: IS_subnational2 },
  { code: "IN", name: "India", states: IN_subnational1, counties: IN_subnational2 },
  { code: "ID", name: "Indonesia", states: ID_subnational1, counties: ID_subnational2 },
  { code: "IR", name: "Iran", states: IR_subnational1, counties: IR_subnational2 },
  { code: "IQ", name: "Iraq", states: IQ_subnational1, counties: IQ_subnational2 },
  { code: "IE", name: "Ireland", states: IE_subnational1, counties: IE_subnational2 },
  { code: "IM", name: "Isle of Man", states: IM_subnational1, counties: IM_subnational2 },
  { code: "IL", name: "Israel", states: IL_subnational1, counties: IL_subnational2 },
  { code: "IT", name: "Italy", states: IT_subnational1, counties: IT_subnational2 },
  { code: "JM", name: "Jamaica", states: JM_subnational1, counties: JM_subnational2 },
  { code: "JP", name: "Japan", states: JP_subnational1, counties: JP_subnational2 },
  { code: "JE", name: "Jersey", states: JE_subnational1, counties: JE_subnational2 },
  { code: "JO", name: "Jordan", states: JO_subnational1, counties: JO_subnational2 },
  { code: "KZ", name: "Kazakhstan", states: KZ_subnational1, counties: KZ_subnational2 },
  { code: "KE", name: "Kenya", states: KE_subnational1, counties: KE_subnational2 },
  { code: "KI", name: "Kiribati", states: KI_subnational1, counties: KI_subnational2 },
  { code: "XK", name: "Kosovo", states: XK_subnational1, counties: XK_subnational2 },
  { code: "KW", name: "Kuwait", states: KW_subnational1, counties: KW_subnational2 },
  { code: "KG", name: "Kyrgyzstan", states: KG_subnational1, counties: KG_subnational2 },
  { code: "LA", name: "Laos", states: LA_subnational1, counties: LA_subnational2 },
  { code: "LV", name: "Latvia", states: LV_subnational1, counties: LV_subnational2 },
  { code: "LB", name: "Lebanon", states: LB_subnational1, counties: LB_subnational2 },
  { code: "LS", name: "Lesotho", states: LS_subnational1, counties: LS_subnational2 },
  { code: "LR", name: "Liberia", states: LR_subnational1, counties: LR_subnational2 },
  { code: "LY", name: "Libya", states: LY_subnational1, counties: LY_subnational2 },
  { code: "LI", name: "Liechtenstein", states: LI_subnational1, counties: LI_subnational2 },
  { code: "LT", name: "Lithuania", states: LT_subnational1, counties: LT_subnational2 },
  { code: "LU", name: "Luxembourg", states: LU_subnational1, counties: LU_subnational2 },
  { code: "MO", name: "Macau", states: MO_subnational1, counties: MO_subnational2 },
  { code: "MG", name: "Madagascar", states: MG_subnational1, counties: MG_subnational2 },
  { code: "MW", name: "Malawi", states: MW_subnational1, counties: MW_subnational2 },
  { code: "MY", name: "Malaysia", states: MY_subnational1, counties: MY_subnational2 },
  { code: "MV", name: "Maldives", states: MV_subnational1, counties: MV_subnational2 },
  { code: "ML", name: "Mali", states: ML_subnational1, counties: ML_subnational2 },
  { code: "MT", name: "Malta", states: MT_subnational1, counties: MT_subnational2 },
  { code: "MH", name: "Marshall Islands", states: MH_subnational1, counties: MH_subnational2 },
  { code: "MQ", name: "Martinique", states: MQ_subnational1, counties: MQ_subnational2 },
  { code: "MR", name: "Mauritania", states: MR_subnational1, counties: MR_subnational2 },
  { code: "MU", name: "Mauritius", states: MU_subnational1, counties: MU_subnational2 },
  { code: "YT", name: "Mayotte", states: YT_subnational1, counties: YT_subnational2 },
  { code: "MX", name: "Mexico", states: MX_subnational1, counties: MX_subnational2 },
  { code: "FM", name: "Micronesia", states: FM_subnational1, counties: FM_subnational2 },
  { code: "MD", name: "Moldova", states: MD_subnational1, counties: MD_subnational2 },
  { code: "MC", name: "Monaco", states: MC_subnational1, counties: MC_subnational2 },
  { code: "MN", name: "Mongolia", states: MN_subnational1, counties: MN_subnational2 },
  { code: "ME", name: "Montenegro", states: ME_subnational1, counties: ME_subnational2 },
  { code: "MS", name: "Montserrat", states: MS_subnational1, counties: MS_subnational2 },
  { code: "MA", name: "Morocco", states: MA_subnational1, counties: MA_subnational2 },
  { code: "MZ", name: "Mozambique", states: MZ_subnational1, counties: MZ_subnational2 },
  { code: "MM", name: "Myanmar", states: MM_subnational1, counties: MM_subnational2 },
  { code: "NA", name: "Namibia", states: NA_subnational1, counties: NA_subnational2 },
  { code: "NR", name: "Nauru", states: NR_subnational1, counties: NR_subnational2 },
  { code: "NP", name: "Nepal", states: NP_subnational1, counties: NP_subnational2 },
  { code: "NL", name: "Netherlands", states: NL_subnational1, counties: NL_subnational2 },
  { code: "NC", name: "New Caledonia", states: NC_subnational1, counties: NC_subnational2 },
  { code: "NZ", name: "New Zealand", states: NZ_subnational1, counties: NZ_subnational2 },
  { code: "NI", name: "Nicaragua", states: NI_subnational1, counties: NI_subnational2 },
  { code: "NE", name: "Niger", states: NE_subnational1, counties: NE_subnational2 },
  { code: "NG", name: "Nigeria", states: NG_subnational1, counties: NG_subnational2 },
  { code: "NU", name: "Niue", states: NU_subnational1, counties: NU_subnational2 },
  { code: "NF", name: "Norfolk Island", states: NF_subnational1, counties: NF_subnational2 },
  { code: "MP", name: "Northern Mariana Islands", states: MP_subnational1, counties: MP_subnational2 },
  { code: "KP", name: "North Korea", states: KP_subnational1, counties: KP_subnational2 },
  { code: "MK", name: "North Macedonia", states: MK_subnational1, counties: MK_subnational2 },
  { code: "NO", name: "Norway", states: NO_subnational1, counties: NO_subnational2 },
  { code: "OM", name: "Oman", states: OM_subnational1, counties: OM_subnational2 },
  { code: "PK", name: "Pakistan", states: PK_subnational1, counties: PK_subnational2 },
  { code: "PW", name: "Palau", states: PW_subnational1, counties: PW_subnational2 },
  { code: "PS", name: "Palestinian Territory", states: PS_subnational1, counties: PS_subnational2 },
  { code: "PA", name: "Panama", states: PA_subnational1, counties: PA_subnational2 },
  { code: "PG", name: "Papua New Guinea", states: PG_subnational1, counties: PG_subnational2 },
  { code: "PY", name: "Paraguay", states: PY_subnational1, counties: PY_subnational2 },
  { code: "PE", name: "Peru", states: PE_subnational1, counties: PE_subnational2 },
  { code: "PH", name: "Philippines", states: PH_subnational1, counties: PH_subnational2 },
  { code: "PN", name: "Pitcairn Islands", states: PN_subnational1, counties: PN_subnational2 },
  { code: "PL", name: "Poland", states: PL_subnational1, counties: PL_subnational2 },
  { code: "PT", name: "Portugal", states: PT_subnational1, counties: PT_subnational2 },
  { code: "PR", name: "Puerto Rico", states: PR_subnational1, counties: PR_subnational2 },
  { code: "QA", name: "Qatar", states: QA_subnational1, counties: QA_subnational2 },
  { code: "RE", name: "Réunion", states: RE_subnational1, counties: RE_subnational2 },
  { code: "RO", name: "Romania", states: RO_subnational1, counties: RO_subnational2 },
  { code: "RU", name: "Russia", states: RU_subnational1, counties: RU_subnational2 },
  { code: "RW", name: "Rwanda", states: RW_subnational1, counties: RW_subnational2 },
  { code: "BL", name: "Saint Barthélemy", states: BL_subnational1, counties: BL_subnational2 },
  { code: "SH", name: "Saint Helena, Ascension, and Tristan da Cunha", states: SH_subnational1, counties: SH_subnational2 },
  { code: "KN", name: "Saint Kitts and Nevis", states: KN_subnational1, counties: KN_subnational2 },
  { code: "LC", name: "Saint Lucia", states: LC_subnational1, counties: LC_subnational2 },
  { code: "MF", name: "Saint Martin (French part)", states: MF_subnational1, counties: MF_subnational2 },
  { code: "PM", name: "Saint Pierre and Miquelon", states: PM_subnational1, counties: PM_subnational2 },
  { code: "VC", name: "Saint Vincent and the Grenadines", states: VC_subnational1, counties: VC_subnational2 },
  { code: "WS", name: "Samoa", states: WS_subnational1, counties: WS_subnational2 },
  { code: "SM", name: "San Marino", states: SM_subnational1, counties: SM_subnational2 },
  { code: "ST", name: "São Tomé and Príncipe", states: ST_subnational1, counties: ST_subnational2 },
  { code: "SA", name: "Saudi Arabia", states: SA_subnational1, counties: SA_subnational2 },
  { code: "SN", name: "Senegal", states: SN_subnational1, counties: SN_subnational2 },
  { code: "RS", name: "Serbia", states: RS_subnational1, counties: RS_subnational2 },
  { code: "SC", name: "Seychelles", states: SC_subnational1, counties: SC_subnational2 },
  { code: "SL", name: "Sierra Leone", states: SL_subnational1, counties: SL_subnational2 },
  { code: "SG", name: "Singapore", states: SG_subnational1, counties: SG_subnational2 },
  { code: "SX", name: "Sint Maarten", states: SX_subnational1, counties: SX_subnational2 },
  { code: "SK", name: "Slovakia", states: SK_subnational1, counties: SK_subnational2 },
  { code: "SI", name: "Slovenia", states: SI_subnational1, counties: SI_subnational2 },
  { code: "SB", name: "Solomon Islands", states: SB_subnational1, counties: SB_subnational2 },
  { code: "SO", name: "Somalia", states: SO_subnational1, counties: SO_subnational2 },
  { code: "ZA", name: "South Africa", states: ZA_subnational1, counties: ZA_subnational2 },
  { code: "GS", name: "South Georgia and South Sandwich Islands", states: GS_subnational1, counties: GS_subnational2 },
  { code: "KR", name: "South Korea", states: KR_subnational1, counties: KR_subnational2 },
  { code: "SS", name: "South Sudan", states: SS_subnational1, counties: SS_subnational2 },
  { code: "ES", name: "Spain", states: ES_subnational1, counties: ES_subnational2 },
  { code: "LK", name: "Sri Lanka", states: LK_subnational1, counties: LK_subnational2 },
  { code: "SD", name: "Sudan", states: SD_subnational1, counties: SD_subnational2 },
  { code: "SR", name: "Suriname", states: SR_subnational1, counties: SR_subnational2 },
  { code: "SJ", name: "Svalbard", states: SJ_subnational1, counties: SJ_subnational2 },
  { code: "SE", name: "Sweden", states: SE_subnational1, counties: SE_subnational2 },
  { code: "CH", name: "Switzerland", states: CH_subnational1, counties: CH_subnational2 },
  { code: "SY", name: "Syria", states: SY_subnational1, counties: SY_subnational2 },
  { code: "TW", name: "Taiwan", states: TW_subnational1, counties: TW_subnational2 },
  { code: "TJ", name: "Tajikistan", states: TJ_subnational1, counties: TJ_subnational2 },
  { code: "TZ", name: "Tanzania", states: TZ_subnational1, counties: TZ_subnational2 },
  { code: "TH", name: "Thailand", states: TH_subnational1, counties: TH_subnational2 },
  { code: "TL", name: "Timor-Leste", states: TL_subnational1, counties: TL_subnational2 },
  { code: "TG", name: "Togo", states: TG_subnational1, counties: TG_subnational2 },
  { code: "TK", name: "Tokelau", states: TK_subnational1, counties: TK_subnational2 },
  { code: "TO", name: "Tonga", states: TO_subnational1, counties: TO_subnational2 },
  { code: "TT", name: "Trinidad and Tobago", states: TT_subnational1, counties: TT_subnational2 },
  { code: "TN", name: "Tunisia", states: TN_subnational1, counties: TN_subnational2 },
  { code: "TR", name: "Türkiye", states: TR_subnational1, counties: TR_subnational2 },
  { code: "TM", name: "Turkmenistan", states: TM_subnational1, counties: TM_subnational2 },
  { code: "TC", name: "Turks and Caicos Islands", states: TC_subnational1, counties: TC_subnational2 },
  { code: "TV", name: "Tuvalu", states: TV_subnational1, counties: TV_subnational2 },
  { code: "UG", name: "Uganda", states: UG_subnational1, counties: UG_subnational2 },
  { code: "UA", name: "Ukraine", states: UA_subnational1, counties: UA_subnational2 },
  { code: "AE", name: "United Arab Emirates", states: AE_subnational1, counties: AE_subnational2 },
  { code: "GB", name: "United Kingdom", states: GB_subnational1, counties: GB_subnational2 },
  { code: "US", name: "United States", states: US_subnational1, counties: US_subnational2 },
  { code: "UM", name: "United States Minor Outlying Islands", states: UM_subnational1, counties: UM_subnational2 },
  { code: "UY", name: "Uruguay", states: UY_subnational1, counties: UY_subnational2 },
  { code: "UZ", name: "Uzbekistan", states: UZ_subnational1, counties: UZ_subnational2 },
  { code: "VU", name: "Vanuatu", states: VU_subnational1, counties: VU_subnational2 },
  { code: "VA", name: "Vatican City (Holy See)", states: VA_subnational1, counties: VA_subnational2 },
  { code: "VE", name: "Venezuela", states: VE_subnational1, counties: VE_subnational2 },
  { code: "VN", name: "Vietnam", states: VN_subnational1, counties: VN_subnational2 },
  { code: "VG", name: "Virgin Islands (British)", states: VG_subnational1, counties: VG_subnational2 },
  { code: "VI", name: "Virgin Islands (U.S.)", states: VI_subnational1, counties: VI_subnational2 },
  { code: "WF", name: "Wallis and Futuna", states: WF_subnational1, counties: WF_subnational2 },
  { code: "EH", name: "Western Sahara", states: EH_subnational1, counties: EH_subnational2 },
  { code: "YE", name: "Yemen", states: YE_subnational1, counties: YE_subnational2 },
  { code: "ZM", name: "Zambia", states: ZM_subnational1, counties: ZM_subnational2 },
  { code: "ZW", name: "Zimbabwe", states: ZW_subnational1, counties: ZW_subnational2 },
];
